import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8c3642d8 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _52b74432 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _b9774720 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _36b01942 = () => interopDefault(import('../../../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _3ac087a0 = () => interopDefault(import('../../../pages/offers.vue' /* webpackChunkName: "pages/offers" */))
const _1df6d427 = () => interopDefault(import('../../../pages/organizations.vue' /* webpackChunkName: "pages/organizations" */))
const _0a39dd20 = () => interopDefault(import('../../../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _42685220 = () => interopDefault(import('../../../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _e7a29d22 = () => interopDefault(import('../../../pages/recipes/index.vue' /* webpackChunkName: "pages/recipes/index" */))
const _4e92266c = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _05b94b31 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _57941828 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _f0870862 = () => interopDefault(import('../../../pages/shoppinglist.vue' /* webpackChunkName: "pages/shoppinglist" */))
const _15924e15 = () => interopDefault(import('../../../pages/tasks.vue' /* webpackChunkName: "pages/tasks" */))
const _3df5f45b = () => interopDefault(import('../../../pages/products/_id/index.vue' /* webpackChunkName: "pages/products/_id/index" */))
const _00637cda = () => interopDefault(import('../../../pages/recipes/_id/index.vue' /* webpackChunkName: "pages/recipes/_id/index" */))
const _0e68a332 = () => interopDefault(import('../../../pages/recipes/_id/edit.vue' /* webpackChunkName: "pages/recipes/_id/edit" */))
const _4cc68d4e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _8c3642d8,
    name: "about___en"
  }, {
    path: "/contact",
    component: _52b74432,
    name: "contact___en"
  }, {
    path: "/login",
    component: _b9774720,
    name: "login___en"
  }, {
    path: "/newsletter",
    component: _36b01942,
    name: "newsletter___en"
  }, {
    path: "/offers",
    component: _3ac087a0,
    name: "offers___en"
  }, {
    path: "/organizations",
    component: _1df6d427,
    name: "organizations___en"
  }, {
    path: "/products",
    component: _0a39dd20,
    name: "products___en"
  }, {
    path: "/profile",
    component: _42685220,
    name: "profile___en"
  }, {
    path: "/recipes",
    component: _e7a29d22,
    name: "recipes___en"
  }, {
    path: "/register",
    component: _4e92266c,
    name: "register___en"
  }, {
    path: "/search",
    component: _05b94b31,
    name: "search___en"
  }, {
    path: "/settings",
    component: _57941828,
    name: "settings___en"
  }, {
    path: "/shoppinglist",
    component: _f0870862,
    name: "shoppinglist___en"
  }, {
    path: "/tasks",
    component: _15924e15,
    name: "tasks___en"
  }, {
    path: "/products/:id",
    component: _3df5f45b,
    name: "products-id___en"
  }, {
    path: "/recipes/:id",
    component: _00637cda,
    name: "recipes-id___en"
  }, {
    path: "/recipes/:id/edit",
    component: _0e68a332,
    name: "recipes-id-edit___en"
  }, {
    path: "/",
    component: _4cc68d4e,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
